<template>
    <div>
        <div class="hello">
            <div class="home" :style="windowWidth < 1441?'width: calc(100% - 40px);':'width: calc(1440px - 40px);'">
                <div class="home_left">
                    <div class="home_left_img">
                        <router-link :to="{path:'/'}" ><img class="home_img" :src="siteLogo" alt=""></router-link>
                    </div>
                    <div class="home_cen">
                        <div v-for="item,index in headList" :key="index">
                            <router-link class="home_cen_title" :to="item.to" :style="headStates == index? 'color: #00B1B2;border-bottom: 3px solid #00B1B2;':'color: #555;'">
                                {{ item.name }}
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="home_right">
                    <div class="home_right" style="cursor: pointer;" @click="loginTo()" v-if="!token">
                        <img class="home_top" src="@/assets/home/icon2.png" alt="">
                        登录注册
                    </div>
                    <div class="home_right" style="cursor: pointer;" v-if="token">
                        <img class="home_top" :src="userInfo.avatar?userInfo.avatar:imgurl" alt="">
                        <el-tooltip class="item" v-if="userInfo.nickname&&userInfo.nickname.length > 4" effect="dark" :content="userInfo.nickname" placement="top-start">
                            <div class="webkit_box">{{ userInfo.nickname || '--' }}</div>
                        </el-tooltip>
                        <div class="webkit_box" v-else>{{ userInfo.nickname || '--' }}</div>
                    </div>
                    <div style="cursor: pointer;margin: 0 30px 0 20px;" class="home_right" @click="centClick()" v-if="token">
                        <img style="width: 19px;object-fit: contain;margin-right: 6px;" src="@/assets/home/fz.png" alt="">
                        个人中心
                    </div>
                    <div class="home_right" style="cursor: pointer;color: #00B1AE;" @click="tcdlClick()" v-if="token">
                        <img style="width: 19px;object-fit: contain;margin-right: 6px;" src="@/assets/home/tc.png" alt="">
                        退出登录
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 100px;"></div>
    </div>
</template>

<script>
import { getConfigdata, getUserInfos } from '@/api/api'
export default {
    name: "HelloWorld",
    props: ['headStates'],
    data() {
        return {
            windowWidth: window.innerWidth,
            headList: [{
				name:'首页',
				to:{
					path:'/'
				}
			},{
				name:'心理测评',
				to:{
					path:'/appraisal'
				}
			},{
				name:'咨询师预约',
				to:{
					path:'/subscribe'
				}
			},{
				name:'文章阅读',
				to:{
					path:'/essay'
				}
			},{
				name:'平台问答',
				to:{
					path:'/terrace'
				}
			}],
            url: 'http://api.7heal.cn/uploads',
            siteLogo: '',
            token: localStorage.getItem('token') || null,
            userInfo: {},
            imgurl: require('@/assets/home/icon2.png')
        };
    },
    watch: {
        windowWidth() {
            this.windowWidth = window.innerWidth;
            this.fullClick();
        },
    },
    mounted() {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        const that = this
		that.fullClick()
        that.getLists()
		window.addEventListener('resize', that.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        getLists() {
            getConfigdata({
                code: 'site_logo'
            }).then(res => {
                this.siteLogo = res.data[0].value
            })
            if(localStorage.getItem('token')) {
                getUserInfos().then(res => {
                    this.userInfo = res.data
                })
            }
        },
        centClick() {
            if(localStorage.getItem('accountType') == 1) {
                this.skipTo('/editPersonage')
            }else {
                this.skipTo('/editCounselor')
            }
        },
        loginTo() {
            localStorage.clear();
            this.$router.push('/login');
        },
        skipTo(e) {
            this.$router.push(e);
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        fullClick(){
			if(this.windowWidth<1056){
				window.location.reload();
			}
		},
        tcdlClick(){
			this.$message.success('退出登录成功！');
			this.$router.push('/login')
			localStorage.clear();
		},
    },
};
</script>

<style scoped lang="less">
.hello {
    width: 100%;
    background: #ffffff;
    display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 99;
}
.home{
	height: 100px;
	display: flex;
	align-items: center;
	justify-content: space-between;
    margin: 0 20px;

    .home_left {
        width: 68%;
        display: flex;
        align-items: center;

        .home_left_img {
            width: 22%;
            margin-right: 6%;
        }
        .home_img {
            width: 100%;
            object-fit: contain;
            cursor: pointer;
        }
        .home_cen {
            width: 60%;
            display: flex;

            .home_cen_title {
                height: 42px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 36px;
                padding: 0 6px;
                cursor: pointer;
                font-weight: bold;
                white-space: nowrap;
                font-size: 16px;
            }
        }
    }
    .home_right {
        display: flex;
        align-items: center;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        white-space: nowrap;

        .home_top {
            width: 35px;
            height: 35px;
            border: 1px solid #EBEBEB;
            margin-right: 12px;
            border-radius: 50%;
        }
    }
}
.webkit_box{
    width: 80px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 15px;
    color: #666666;
    white-space: nowrap;
    display: -webkit-box; /* 使用旧版弹性盒子模型 */
    -webkit-box-orient: vertical; /* 垂直排列 */
    -webkit-line-clamp: 1; /* 限制显示行数 */
    overflow: hidden; /* 隐藏溢出内容 */
    text-overflow: ellipsis; /* 显示省略号 */
    word-break: break-word; /* 允许单词内断行 */
}
</style>
